const ELEMENT_NODE = 1;
const TEXT_NODE = 3;

const noop = () => { /* noop */ };

function dohighlight(context, re, elementName, className) {
	const nodeQueue = [context];
	let node;
	// eslint-disable-next-line curly
	while ((node = nodeQueue.shift()) != null) {
		if (node.nodeType == ELEMENT_NODE && node.firstChild) {
			const elt = node;
			if (/(script|style)/i.test(elt.tagName))
				continue;
			if (elt.tagName === elementName && elt.className === className)
				continue;
			nodeQueue.push(...Array.from(node.childNodes));
		} else if (node.nodeType === TEXT_NODE) {
			const textNode = node;
			const match = textNode.data.match(re);
			if (match) {
				const mark = document.createElement(elementName);
				mark.className = className;
				const wordNode = textNode.splitText(match.index);
				wordNode.splitText(match[0].length);
				const nextWord = wordNode.nextSibling; // we just split it, so it has to exist
				const wordClone = wordNode.cloneNode(true);
				mark.append(wordClone);
				wordNode.replaceWith(mark);
				nodeQueue.unshift(nextWord);
			}
		}
	}
}

const defaultOptions = { element: 'mark', className: 'v3-highlight', caseSensitive: false, wordsOnly: false };

function unhighlight(context, options = {}) {
	const { element, className } = { ...defaultOptions, ...options };
	context.querySelectorAll(`${element}.${className}`).forEach(el => {
		const parent = el.parentNode;	
		el.replaceWith(el.firstChild);
		parent.normalize();
	});
}

function highlight(context, words, options = {}) {
	const { element, className, caseSensitive, wordsOnly } = { ...defaultOptions, ...options };

	let properWords = Array.isArray(words) ? words : [words];

	properWords = properWords.filter(word => word !== "");

	if(properWords.length === 0)
		return noop;

	// Regex-escape the words
	properWords = properWords.map(word => word.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&"));

	let pattern = `(${properWords.join("|")})`;
	if (wordsOnly)
		pattern = `\\b${pattern}\\b`;

	const re = new RegExp(pattern, caseSensitive ? "" : "i");

	dohighlight(context, re, element.toUpperCase(), className);

	return () => unhighlight(context, options);
}

function init(context, selector = "[data-js-highlight]") {
	(context || document).querySelectorAll(selector).forEach(el => {
		highlight(el, el.dataset.jsHighlight);
	});
}

export { init, highlight, unhighlight };